<template>
  <div class="FileExplorer">
    <el-dialog
      :close-on-click-modal="false"
      :show-close="false"
      :append-to-body="true"
      title="选择导入"
      :visible.sync="$props.value"
    >
      <!-- <div class="title">导入课件</div> -->
      <!-- <div class="top">
        <div class="father">
          <div class="box1" :class="{box1active:navvalue==1}" @click="change(1)">本校资源</div>
          <div class="box1" :class="{box1active:navvalue==2}" @click="change(2)">外校资源</div>
          <div class="box1" :class="{box1active:navvalue==3}" @click="change(3)">教材</div>
          <div class="box1 " style="margin-right: 0;" :class="{box1active:navvalue==4}" @click="change(4)">资源库</div>
          <div class="box1 " style="margin-right: 0;" :class="{box1active:navvalue==5}" @click="change(5)">MOOC资源</div>
          <div v-if="sixstatus" class="box1 " style="margin-right: 0;" :class="{box1active:navvalue==6}" @click="change(6)">教学大赛</div>
        </div>
      </div> -->
      <div class="content">
        <div>
          <el-select
            v-if="navvalue == 2"
            v-model="schoolname"
            size="mini"
            style="margin-right: 20px"
            placeholder="请输入学校名字"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-input
            v-if="navvalue !== 4"
            v-model="techername"
            size="mini"
            prefix-icon="el-icon-search"
            style="width: 200px"
            placeholder="输入课程名或教师名搜索"
          />
        </div>
        <div class="body">
          <div v-for="item in 4" :key="item" class="item">
            <div class="img" />
            <div>
              <div class="name">建筑学</div>
              <div class="x">XXX</div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisiblefn">关 闭</el-button>
        <el-button
          v-if="navvalue != 1 && navvalue != 2"
          type="primary"
          @click="dialogTableVisiblefn"
        >
          选 择
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: 'FileExplorer',
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    sixstatus: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogTableVisible: this.value,
      wj: '',
      navvalue: 1,
      techername: '',
      options: [
        { value: '1', name: '齐齐哈尔大学' },
        { value: '2', name: '山东大学' },
      ],
    }
  },
  computed: {},
  created() {},
  methods: {
    dialogTableVisiblefn() {
      this.$emit('changefn', false)
    },
    change(str) {
      this.navvalue = str
    },
  },
}
</script>

<style scoped lang="scss">
.body {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  margin-top: 20px;
  max-height: 360px;
  overflow: auto;
}
:deep(.el-dialog) {
  min-width: 805px !important;
  width: 35%;
}
.item {
  width: 130px;
  height: 160px;
  border: 1px solid #d8e0f0;
  border-radius: 4px;
  text-align: center;
  margin-right: 20px;
  margin-bottom: 20px;
  .name {
    font-size: 16px;
    font-weight: 600;
    margin: 11px;
  }
  .x {
    font-size: 14px;
  }
  .img {
    width: 100%;
    height: 80px;
    background-color: #f4f9fd;
    border-bottom: 1px solid #d8e0f0;
  }
}
.item:hover {
  color: var(--primary);
  cursor: pointer;
}
.top {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.father {
  display: flex;
  background-color: #e6edf5;
  padding: 4px;
  border-radius: 25px;
  width: fit-content;
  width: 100%;
  .box1 {
    padding: 9px 30px;
    font-size: 14px;
    border-radius: 12px;
    // transition: all 0.25s;
    cursor: pointer;
    margin-right: 4px;
  }
  // .box1:hover{
  //   // background-color: var(--primary);
  //   // color: var(--primary);
  // }
  .box1active {
    background-color: var(--primary);
    color: white;
  }
}
</style>
